import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { ChatInboxModel } from '@/models'

export interface CreateCustomChatInboxRequest {
  buildingId: number
  name: number
  memberIds: number
}

export const createCustomChatInbox = async (data: CreateCustomChatInboxRequest) => {
  const response = await authAPI.post<ChatInboxModel>('/chat-inbox/custom', data)
  return response.data
}

export const useCreateCustomChatInbox = () => {
  return useMutation({
    mutationFn: createCustomChatInbox,
  })
}
